document.addEventListener("DOMContentLoaded", () => {
  const storeNameEl = document.getElementById("store_name");
  const priceEl = document.getElementById("product_price_input");

  if (!storeNameEl || !priceEl) return;

  const storeName = storeNameEl.value?.trim();
  const price = priceEl.value?.trim();

  if (!storeName || !price) return;

  function extractPriceValue(priceText) {
    const cleaned = priceText
      .replace(/\s/g, "")
      .replace(/[^\d,.]/g, "");

    if (!cleaned) return 0;

    // Norwegian/Swedish format: 1.499,00
    if (cleaned.includes(",")) {
      return (
        Number(
          cleaned
            .replace(/\./g, "")
            .replace(",", ".")
        ) || 0
      );
    }

    return Number(cleaned.replace(/\./g, "")) || 0;
  }

  function formatNumber(number) {
    return Math.round(Number(number) || 0);
  }

  function formatPercentage(number) {
    const value = Number(number) || 0;

    // Keeps decimals when needed, e.g. 5.5%, but displays 5 instead of 5.00
    return Number(value.toFixed(2));
  }

  function getTargetElement(productChoose) {
    switch (productChoose) {
      case "all":
        return document.getElementById("bonus-tag-for-all");

      case "specific":
        return document.getElementById("bonus-tag-for-original");

      default:
        return document.getElementById("bonus-tag-for-sale");
    }
  }

  function renderBonusTag({
    url,
    textColor,
    backgroundColor,
    bonus,
    percentage,
    displayMode
  }) {
    const bonusText =
      displayMode === "percentage_only"
        ? `Tjäna ${formatPercentage(percentage)}% i bonus`
        : `Tjäna ${formatNumber(bonus)} kr i bonus`;

    return `
      <a
        href="${url}"
        class="sale-price-text"
        style="
          padding: 4px 20px;
          color: ${textColor};
          background: ${backgroundColor};
          display: inline-block;
          margin: 14px 0;
          border-radius: 5px;
        "
      >
        ${bonusText}
      </a>
    `;
  }

  const priceValue = extractPriceValue(price);

  fetch("https://dialog.modish.no/api/tag-attributes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      store_name: storeName
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(
          `Request failed with status ${response.status}`
        );
      }

      return response.json();
    })
    .then(data => {
      const {
        percentage = 0,
        background_color: backgroundColor = "",
        text_color: textColor = "",
        product_choose: productChoose = "",
        display_mode: displayMode = "calculated_amount",
        status = 0,
        url = "#"
      } = data;

      if (Number(status) !== 1) return;

      const bonus =
        (priceValue * Number(percentage)) / 100;

      const targetElement =
        getTargetElement(productChoose);

      if (!targetElement) return;

      targetElement.innerHTML = renderBonusTag({
        url,
        textColor,
        backgroundColor,
        bonus,
        percentage,
        displayMode
      });
    })
    .catch(error => {
      console.error("Failed to load bonus tag:", error);
    });
});